import { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const useFileUpload = ({
  fieldId = 'single',
  multiple = false,
  accept = {
    'image/*': ['.jpeg', '.jpg', '.png'],
  },
  initialFile = null,
} = {}) => {
  const [uploadedFiles, setUploadedFiles] = useState({ [fieldId]: null });
  const [removedFiles, setRemovedFiles] = useState({});

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles?.length > 0) {
      setUploadedFiles(prev => ({
        ...prev,
        [fieldId]: acceptedFiles[0],
      }));

      setRemovedFiles(prev => ({
        ...prev,
        [fieldId]: false,
      }));
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    accept,
    onDrop,
  });

  const resetFile = useCallback(() => {
    setUploadedFiles(prev => ({
      ...prev,
      [fieldId]: null,
    }));

    setRemovedFiles(prev => ({
      ...prev,
      [fieldId]: true,
    }));
  }, []);

  const clearState = useCallback(() => {
    setUploadedFiles({ [fieldId]: null });
    setRemovedFiles({});
  }, [fieldId]);

  return {
    file: uploadedFiles[fieldId],
    initialFile,
    isRemoved: removedFiles[fieldId],
    hasChanged: uploadedFiles[fieldId] !== null || removedFiles[fieldId],
    getRootProps,
    getInputProps,
    resetFile,
    clearState,
  };
};

export default useFileUpload;
